<template>
    <inline-svg :src="iconSource" :style="colorStyle(color)"></inline-svg>
</template>

<script>
    import InlineSvg from 'vue-inline-svg';
    export default {
        name: "design-2021-apprentice-inline-svg-component",
         components: {
            InlineSvg
        },
        props: {
            iconSource: {
                type: String,
                required: true,
            },
            color: {
                type: String,
                default: '',
            }
        },
        methods: {
            colorStyle(color) {
                return (color) ? { 'fill': color,} : null;
            },
        }
    }
</script>

<style scoped>

</style>
